import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { MapAddress } from '@/types/address';

type State = {
  totalOnlineShop: number;
};

type Actions = {
  setTotalOnlineShop: (value: number) => void;
};

export const useOnlineShopTotalCount = create<State & Actions>()(
  persist(
    (set) => ({
      totalOnlineShop: 0,

      setTotalOnlineShop: (value: number) => {
        set({ totalOnlineShop: value });
      },
    }),
    { name: 'place_name' }
  )
);
